<template>
  <v-container>
    <v-layout row align-center class="mb-3">
      <v-flex grow>
        <span class="title">Dead Link Checker</span>
      </v-flex>
      <v-flex shrink>
        <v-btn color="primary" :disabled="checking" @click="checkNow">
          {{ checking ? "Testing links..." : "Check Now" }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-progress-linear
      v-if="checking"
      :value="progressPercent"
      color="primary"
      height="8"
      class="mb-3"
    >
      <span class="caption">
        {{ progressCompleted }} / {{ progressTotal }}
      </span>
    </v-progress-linear>

    <v-data-table
      :headers="headers"
      :items="deadLinks"
      :loading="checking"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.listing_title }}</td>
        <td>
          <a :href="props.item.url" target="_blank" rel="noopener noreferrer">
            {{ props.item.url }}
          </a>
        </td>
        <td>
          {{
            props.item.status_code === 403
              ? "Blocked / Unverifiable (403)"
              : props.item.status_code || "Timeout / No Response"
          }}
        </td>
        <td>{{ formatDate(props.item.checked_at) }}</td>
      </template>
      <template v-slot:no-data>
        <span v-if="checking">Testing links, please wait...</span>
        <span v-else>No dead links found.</span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      checking: false,
      progressCompleted: 0,
      progressTotal: 0,
      pollInterval: null,
      headers: [
        { text: "Listing", value: "listing_title" },
        { text: "URL", value: "url" },
        { text: "Status", value: "status_code" },
        { text: "Last Checked", value: "checked_at" }
      ]
    };
  },
  computed: {
    deadLinks() {
      return this.$store.state.deadLinks;
    },
    progressPercent() {
      if (!this.progressTotal) return 0;
      return Math.round((this.progressCompleted / this.progressTotal) * 100);
    }
  },
  mounted() {
    this.$store.dispatch("fetchDeadLinks");
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    async checkNow() {
      this.checking = true;
      this.progressCompleted = 0;
      this.progressTotal = 0;
      this.startPolling();
      try {
        await this.$store.dispatch("checkDeadLinks");
      } finally {
        this.stopPolling();
        this.checking = false;
      }
    },
    startPolling() {
      this.pollInterval = setInterval(async () => {
        const progress = await this.$store.dispatch("fetchDeadLinksProgress");
        this.progressCompleted = progress.completed;
        this.progressTotal = progress.total;
      }, 500);
    },
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleString();
    }
  }
};
</script>
